import { ReactComponent as AccountCircle } from '../../icons/account_circle.svg';
import { ReactComponent as ArrowDown } from '../../icons/keyboard_arrow_down.svg';
import { ReactComponent as ArrowUp } from '../../icons/expand_less.svg';
import { iconStyle } from '../shared/stylization';
import './userField.scss';
import { useCallback, useContext, useEffect, useRef, useState } from "react";
import Navbar from "../shared/navbar/navbar";
import { ClassNameNavbar, Option } from "../shared/navbar/types/navbarProps";
import AuthContext, { Roles } from "../../contexts/authContext";
import { GetUserId, Logout } from "../../services/signInService/signInService";
import { apiContext } from "../../contexts/apiContext";
import { portalUserService } from "../../services/arcGisService/arcGisService";
import { ArcGisServiceProps } from "../../services/arcGisService/types/arcGisServiceProps";
import RolesToPermissions, { UserIdToExtendedPermissions, offlineModePermissions, defaultExtendedPermissions } from "../../helpers/rolesToPermissions";
import PermissionsContext from "../../contexts/permissionsContext";
import UserOptions from "./userOptions/userOptions";
import { getUserConfig, getUserPermissionsIdb, setLoggedUser, setUserConfigIdb, setUserPermissionsIdb, setUsersForMessages } from "../../database/indexedDbReadWrite";
import { useClickOutside } from "../../hooks/clickOutsideHook";
import { UserPermissions } from '../../database/indexedDbConfig';
import { getUsers } from '../../services/processService/processService';
import { checkIfNewRole } from '../../helpers/processHelper';
import { SortType, TableContext } from '../../contexts/tableContext';

const UserField = () => {
    const [menuOpened, setMenuOpened] = useState(false);
    const [showUserOptions, setShowUserOptions] = useState(false);
    const { user, username, setAuthenticated, setUserRoles, setUser, setUserId, setOnlineMode, onlineMode } = useContext(AuthContext);
    const { apiUrl, apiVersion } = useContext(apiContext);
    const { setFunctionsPermissions, functionsPermissions, setExtendedUserPermissions } = useContext(PermissionsContext);
    const { setFiltersTableDb, setFiltersTableTaskList, setSortConfigDb, setSortConfigTaskList } = useContext(TableContext);
    const wrapperRef = useRef<HTMLDivElement>(null);
    useClickOutside(wrapperRef, () => {
        setMenuOpened(false);
    });

    const userFieldToggle = () => {
        setMenuOpened(!menuOpened);
    }
    const { portalUrl } = useContext(apiContext);

    var login = sessionStorage.getItem("isActiveLoginSOPO");

    const onClickUserLogout = useCallback(() => {
        Logout(apiUrl, apiVersion)?.then((response: any) => {
            sessionStorage.removeItem("SOPOtoken");
            sessionStorage.removeItem("guidSession");
            setAuthenticated(false);
            setOnlineMode(false);
            sessionStorage.removeItem("SOPOonline");
            setUser('');
            setLoggedUser({name: "logged", val: ""})
            sessionStorage.removeItem("isActiveLoginSOPO");
            setUserId("-1");
            clearFilters();
        }).catch((error: any) => {
            setAuthenticated(false);
            setOnlineMode(false);
            sessionStorage.removeItem("SOPOonline");
            setUser('');
            sessionStorage.removeItem("isActiveLoginSOPO");
            setUserId("-1");
            clearFilters();
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [apiUrl, apiVersion, setAuthenticated, setOnlineMode, setUser, setUserId]);

    const clearFilters = () => {
        setFiltersTableDb([]);
        setFiltersTableTaskList([]);
        setSortConfigDb({ sortType: SortType.None, filterColumnName: "" });
        setSortConfigTaskList({ sortType: SortType.None, filterColumnName: "" });
    }

    const initOnlineUser = useCallback((prevPermissions?: UserPermissions) => {
        var arcGisServiceProps: ArcGisServiceProps = {
            url: portalUrl + "/sharing/rest/community/users/" + login
        }
        portalUserService(arcGisServiceProps).then((value: any) => {
            setUser(value.fullName);
            getUserConfig(value.username).then((response) => {
                if(response){
                    response!.name = value.fullName;
                    setUserConfigIdb(response);
                }
            })
            if (value != null && value !== undefined) {
                var roles: [] = value.groups.map((group: any) => {
                    return group.title;
                })
                if (roles.length < 1) {
                    onClickUserLogout();
                } else {
                    if (prevPermissions === undefined || JSON.stringify(prevPermissions.roles) !== JSON.stringify(roles)) {
                        setUserRoles(roles);
                    }

                    //TODO: change to one method!
                    GetUserId(apiUrl, apiVersion)
                    .then((userIdRes: any) => {
                        setUserId(userIdRes.id as string)

                        if (userIdRes.id) {
                            if (roles.find((item: string) => item === Roles.PwaEditor || item === Roles.PwaEditorExtended) || checkIfNewRole(roles)) {
                                UserIdToExtendedPermissions(userIdRes.id, apiUrl + apiVersion)
                                .then((exRes: any) => {
                                    if (prevPermissions === undefined || JSON.stringify(prevPermissions.extended) !== JSON.stringify(exRes)) {
                                        setExtendedUserPermissions(exRes);
                                    }

                                    if (exRes.success) {
                                        RolesToPermissions(roles, apiUrl + apiVersion)
                                        .then((rtpRes: any) => {
                                            let pRes = rtpRes.permissions;
                                            if (prevPermissions === undefined || JSON.stringify(prevPermissions.permissions) !== JSON.stringify(pRes)) {
                                                setFunctionsPermissions(pRes);
                                            }
                                            if (login) setUserPermissionsIdb({ name: login, roles: roles, permissions: pRes, extended: exRes });
                                        })
                                        .catch(() => { });
                                    }
                                })
                            } else {
                                RolesToPermissions(roles, apiUrl + apiVersion)
                                .then((rtpRes: any) => {
                                    let pRes = rtpRes.permissions;
                                    if (prevPermissions === undefined || JSON.stringify(prevPermissions.permissions) !== JSON.stringify(pRes)) {
                                        setFunctionsPermissions(pRes);
                                    }
                                    if (login) setUserPermissionsIdb({ name: login, roles: roles, permissions: pRes, extended: defaultExtendedPermissions() });
                                })
                                .catch(() => {});
                            }
                        }
                    }).catch(() => {});
                }
            } else {
                onClickUserLogout();
            }

        }).catch((error: any) => { 
            console.log(error);
            onClickUserLogout(); 
        }).finally(() => { });
    }, [apiUrl, apiVersion, login, onClickUserLogout, portalUrl, setExtendedUserPermissions, setFunctionsPermissions, setUser, setUserId, setUserRoles]);

    const setMsgUsers = useCallback(() => {
        getUsers(apiUrl + apiVersion)
            .then((res: any) => { setUsersForMessages(res); })
            .catch(() => { console.error("failure to retrieve message recipients") })
    }, [apiUrl, apiVersion])

    useEffect(() => {
        if (onlineMode) {
                if (login !== null) {
                    getUserPermissionsIdb(login).then(res => {
                        if (res) {
                            setUserRoles(res.roles);
                            setFunctionsPermissions(res.permissions);
                            setExtendedUserPermissions(res.extended);

                            initOnlineUser(res);
                        } else {
                            initOnlineUser(); 
                        }
                    }, (err) => {
                        console.error(err);
                        initOnlineUser(); 
                    });
                } else {
                    initOnlineUser(); 
                }

                setMsgUsers();
        } else {
            getUserConfig(username)
            .then((res: any) => {
                if (res) setUser(res.name);
            })
            setFunctionsPermissions(offlineModePermissions());
        }

    }, [login, portalUrl, setFunctionsPermissions, setUser, setUserRoles, onlineMode, setExtendedUserPermissions, initOnlineUser, username, setMsgUsers]);

    const arrowIcon = () => {
        if (menuOpened) return (<ArrowUp className='userFieldExpandLessIcon userFieldIcon' style={iconStyle}></ArrowUp>);
        return (<ArrowDown className='userFieldIcon' style={iconStyle}></ArrowDown>);
    }

    const onClickUserOptions = () => {
        setMenuOpened(false);
        setShowUserOptions(true);
    }

    const onCloseUserOptions = () => {
        setShowUserOptions(false);
    }

    const navbarOptions: Option[] = [
        ...functionsPermissions.userConfig.active ? [{ name: 'Moje ustawienia', onClick: onClickUserOptions, disabled: !onlineMode }] : [],
        { name: 'Wyloguj', onClick: onClickUserLogout }
    ]

    return (
        <>
            <div onClick={userFieldToggle} className="userField" ref={wrapperRef}>
                <AccountCircle className='userFieldIcon' style={{...iconStyle, fill: "#453F3A"}}></AccountCircle>
                <span className="body-txt-medium" title={user}>{user}</span>
                {arrowIcon()}
                <Navbar rolledOut={menuOpened} options={navbarOptions} addClass={`navbarMenuUsername ${ClassNameNavbar.menu}`} />
            </div>
            {showUserOptions && 
                <UserOptions onClose={onCloseUserOptions}/>
            }
        </>
    )
}

export default UserField;